"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invokeExpressionValidator = void 0;
const ts_types_1 = require("@waves/ts-types");
const validators_1 = require("./validators");
const invokeScheme = {
    type: validators_1.isEq(ts_types_1.TRANSACTION_TYPE.INVOKE_EXPRESSION),
    senderPublicKey: validators_1.isPublicKey,
    version: validators_1.isEq(1),
    expression: validators_1.isBase64,
    fee: validators_1.isNumberLike,
    feeAssetId: validators_1.isAssetId,
    chainId: validators_1.isNumber,
    timestamp: validators_1.isNumber,
    proofs: validators_1.ifElse(validators_1.isArray, validators_1.defaultValue(true), validators_1.orEq([undefined])),
};
exports.invokeExpressionValidator = validators_1.validateByShema(invokeScheme, validators_1.getError);
//# sourceMappingURL=invoke-expression.js.map